<template>
	<router-view :data="event" v-if="dataReady"></router-view>
</template>
<script>
import eventHTTP from '@/api/modules/event/event'
export default {
	data () {
		return {
			dataReady: false,
			id: null,
			event: {}
		}
	},
	created () {
		this.id = parseInt(this.$route.params.id)
		this.getEvent()
	},
	methods: {
		getEvent () {
			eventHTTP.findOne(this.id).then((event) => {
				this.event = event
				this.setTitle()
				this.setBreadcrumb()
				this.dataReady = true
			}, (response) => {
				this.dataReady = true
			})
		},
		setTitle () {
			document.title = this.event.product.title
		},
		setBreadcrumb () {
			const breadcrumb = document.querySelector('.breadcrumb')
			const items = breadcrumb.getElementsByTagName('li')

			if (items.length > 0) {
				const li = document.createElement('li')
				li.className = items[0].className
				li.innerText = this.event.product.title
				breadcrumb.appendChild(li)
			}
		},
		removeBreadcrumb () {
			const breadcrumb = document.querySelector('.breadcrumb')
			const listItems = breadcrumb.getElementsByTagName('li')
			const last = listItems[listItems.length - 1]
			last.parentNode.removeChild(last)
		}
	},
	beforeDestroy () {
		this.removeBreadcrumb()
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/event/viewTabs/layout.vue